/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { closeTabId, multiPanelAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { Button } from '@material-ui/core';
import './NormalViewContractDetail.css';

import LoadingPanel from '@/component/common/LoadingPanel';
import UpdateContract from './UpdateContract/UpdateContract';
import UpdateContractConfirm from './UpdateContractConfirm/UpdateContractConfirm';
import ChoosePaymentConfirm from './ChoosePaymentConfirm/ChoosePaymentConfirm';
import TranslationHistoryModal from '@/component/rootOrganization/modal/TranslationHistoryModal';

import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { CONTRACT_SCREEN_MANAGEMENT } from '@/common/constant/NormalContractManagementConstant';
import { initContractDetail } from '@/component/rootOrganization/EditOrganizationHandler';
import { corporationAtom } from '@/state/atom/corporationAtom';
import {
    handleRedirect,
    currentContract,
    usingStageStatus,
    usingFunctions,
    hanldeShowDialogPolicy,
    handleCustomInitUpdateContractState,
    onClickReloadData,
    closeBtnUpdateContract
} from './NormalViewContractDetailHanlder.js';
import DialogPolicy from './DialogPolicy';
import { userAtom } from '@/state/atom/userAtom';
import { useSnackbar } from 'notistack';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import trI18n from '@/common/utils/trI18n';
import useTranslationSubscription from '@/hooks/useTranslation';

export default function NormalViewContractDetail(props) {
    useTranslationSubscription();
    const { enqueueSnackbar } = useSnackbar();
    const corporationDetail = useRecoilValue(corporationAtom);
    const [isLoading, setIsLoading] = useState(false);
    const [labelUser, setLabelUser] = useState(true);
    const [labelUsageStatus, setLabelUsageStatus] = useState(true);
    const [labelUsedFunctions, setLabelUsedFunctions] = useState(true);
    const [contractDetail, setContractDetail] = useState({});
    const [corpLimitValue, setCorpLimitValue] = useState({});
    const [currentScreen, setCurrentScreen] = useState(
        CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.SCREEN
    );
    const [redirectBtns, setRedirectBtns] = useState(
        CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.REDIRECT_BUTTONS
    );

    const [isUpdateConfirm, setIsUpdateConfirm] = useState(false);
    const [updateContractData, setUpdateContractData] = useState({})

    const [onSaleProductList, setOnSaleProductList] = useState([]);
    const [onSaleEditionList, setOnSaleEditionList] = useState([]);
    const [product, setProduct] = useState({});
    const [edition, setEdition] = useState({});
    const [version, setVersion] = useState({});
    const [paymentCycle, setPaymentCycle] = useState('');
    const [payment, setPayment] = useState();
    const [basicSetting, setBasicSetting] = useState({});
    const [advanceSetting, setAdvanceSetting] = useState({})

    const [isOpenPolicy, setOpenPolicy] = useState(false);

    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [paymentMethod, setPaymentMethod] = useState(
        CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.PAYMENT_METHOD.BANK_TRANSFER
    );
    const [checkErr, setCheckErr] = useState(false);
    const userDetail = useRecoilValue(userAtom);
    const [isShowPopUpReload, setIsShowPopUpReload] = useState({isOpen: false, message: ''});
    const [triggerReload, setTriggerReload] = useState('');
    const [amountValue, setAmountValue] = useState(0);
    const [currentVersionInfo, setCurrentVersionInfo] = useState({});
    const [resetData, setResetData] = useState({});
    const [isShowPopupCancel, setIsShowPopupCancel] = useState(false);
    const [currentPaymentCycle, setCurrentPaymentCycle] = useState('')
    const [corporationData, setCorporationData] = useState({});
    const [cataLogData, setCataLogData] = useState([]);
    // null when closed; otherwise the usage type whose history modal is open ('FILE' | 'TEXT').
    const [translationHistoryType, setTranslationHistoryType] = useState(null);

    useEffect(() => {
        setIsLoading(true);
        initContractDetail(props?.API, corporationDetail.id)
            .then(data => {
                if (!data || Utils.isEmptyObject(data)) return setIsLoading(false);
                setContractDetail(data);
                setCorpLimitValue(data?.corporationData?.limitValue);
                setCorporationData(data?.corporationData);
                setCataLogData(data?.cataLogData || []);
                handleCustomInitUpdateContractState(
                    data,
                    setOnSaleProductList,
                    setOnSaleEditionList,
                    setProduct,
                    setEdition,
                    setVersion,
                    setPaymentCycle,
                    setPayment,
                    setBasicSetting,
                    setAdvanceSetting,
                    setResetData,
                    setCurrentVersionInfo,
                    setCurrentPaymentCycle
                );

                setIsLoading(false);
            })
            .catch(error => {
                console.error('initContractDetail >>> error >>>', error)
                setIsLoading(false);
            });
    }, [corporationDetail.id, triggerReload]);

    // close tabid
    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
            if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
            closePanelTab({
                event: null,
                panelType: currentPanelInfo.type,
                panelId: props.panelId,
                tabId: props.tabId
            });
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    const hanldeToggleCollapse = collapse => (collapse ? 'accordionForm--show' : '');

    const handleToggleSection = setCollapse => {
        setTranslationHistoryType(null);
        setCollapse(prev => !prev);
    };

    const showClassUsingStage = ({ item, usageStageItems }) => {
        let className = 'accordion normal-underline';
        const visibleUsageStageItems = usageStageItems?.filter(usageItem => usageItem.enable) || [];
        const lastVisibleUsageStageItem = visibleUsageStageItems[visibleUsageStageItems.length - 1];
        if (lastVisibleUsageStageItem === item) {
            className = className.replace(' normal-underline', '');
        }
        if (item.limit < item.used) {
            className += ' normal-error';
        }
        if (item.custom) {
            className += ' root-custom';
        }
        return className;
    };

    const renderTranslationUsage = ({ item, usageStageItems, usageType }) => {
        const visibleUsageStageItems = usageStageItems?.filter(usageItem => usageItem.enable) || [];
        const lastVisibleUsageStageItem = visibleUsageStageItems[visibleUsageStageItems.length - 1];
        const underlineClassName = lastVisibleUsageStageItem === item ? '' : ' normal-underline';

        return (
            <div
                key={item.label}
                className={`normal-file-translation-usage${underlineClassName}`}
            >
                <div className="normal-file-translation-header">
                    <span className="normal-label">{item.label}</span>
                    <button
                        type="button"
                        className="normal-translation-history-btn"
                        onClick={() => setTranslationHistoryType(usageType)}
                    >
                        {trI18n('LABEL-TRANSLATION-HISTORY')}
                    </button>
                </div>
                {item.listItems?.map(child => (
                    <div className="normal-file-translation-child" key={child.label}>
                        <span className="normal-label">{child.label}</span>
                        <span className="normal-content">
                            <span className="fs-15 fw-500">
                                {child.used}
                            </span>
                            &nbsp;
                            {child.subLabel}
                        </span>
                    </div>
                ))}
            </div>
        );
    };

    const renderUsingStageItem = ({ item, usageStageItems }) => {
        if (!item.enable) return null;
        if (item.type === Constant.ROOT_CORPORATION.RESOURCE_TYPE.FILE_TRANSLATION_USAGE) {
            return renderTranslationUsage({
                item,
                usageStageItems,
                usageType: Constant.ROOT_CORPORATION.TRANSLATION_USAGE_TYPE.FILE
            });
        }
        if (item.type === Constant.ROOT_CORPORATION.RESOURCE_TYPE.TEXT_TRANSLATION_USAGE) {
            return renderTranslationUsage({
                item,
                usageStageItems,
                usageType: Constant.ROOT_CORPORATION.TRANSLATION_USAGE_TYPE.ON_DEMAND_TEXT
            });
        }

        return (
            <div
                key={item.label}
                className={showClassUsingStage({ item, usageStageItems })}
            >
                <span className="normal-label">
                    {item.label}
                </span>
                <span className="normal-content">
                    <span className="fs-15 fw-500">
                        {item.used} / {item.limit}
                    </span>
                    &nbsp;
                    {item.subLabel}
                </span>
            </div>
        );
    };

    const isError = (max, min) => (max < min ? 'normal-error' : '');

    useEffect(() => {
        setTranslationHistoryType(null);
        switch (currentScreen) {
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.SCREEN:
                setRedirectBtns(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.REDIRECT_BUTTONS);
                break;
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN:
                setRedirectBtns(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.REDIRECT_BUTTONS);
                break;
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE_CONFRIM.SCREEN:
                setRedirectBtns(
                    CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE_CONFRIM.REDIRECT_BUTTONS
                );
                break;
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.SCREEN:
                setRedirectBtns(
                    CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.REDIRECT_BUTTONS
                );
                break;
            default:
                break;
        }
    }, [currentScreen]);

    const handleRenderScreen = screen => {
        switch (screen) {
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.SCREEN:
            {
                const usageStageItems = usingStageStatus(
                    contractDetail?.corporationData,
                    contractDetail?.contractDetail,
                    contractDetail?.versionData
                );
                return (
                    <>
                        <div className="normal-product">
                            {currentContract(contractDetail).map(item => (
                                <div className="product-expied normal-underline" key={item.label}>
                                    <span className="normal-label">{item.label}</span>
                                    {!Utils.isEmpty(item.isNameProduct) ? (
                                        <OverFlowTooltipWithTabsMui
                                            className="normal-content d-inline-block w-50 text-right"
                                            value={item.content}
                                        />
                                    ) : (
                                        <span className="normal-content">{item.content}</span>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="normal-collapse">
                            {/* LABEL-USER */}
                            <div
                                className={`accordionForm ${hanldeToggleCollapse(labelUser)}`}
                                id="label-user"
                            >
                                <label
                                    className="accordionHead accordionHead-text"
                                    onClick={() => handleToggleSection(setLabelUser)}
                                >
                                    {trI18n('LABEL-USER')}
                                </label>
                                <div className="accordionContent">
                                    <div className="accordion normal-underline pt-1">
                                        <span className="normal-label">
                                            {trI18n('LABEL-TABLE-USAGE-DETAIL')}
                                        </span>
                                        <span className="normal-content">
                                            {trI18n('LABEL-TABLE-USAGE-STATUS')}
                                        </span>
                                    </div>
                                    <div
                                        className={`accordion ${isError(
                                            corpLimitValue?.maxNumOfGeneralUser,
                                            corpLimitValue?.numOfGeneralUser
                                        )}`}
                                    >
                                        <span className="normal-label">
                                            {trI18n('LABEL-NUMBER-OF-GENERAL-USER')}
                                        </span>
                                        <span className="normal-content">
                                            {/* <span>(パートナー 2)</span> // out scoped */}
                                            {corpLimitValue?.numOfGeneralUser || 0} /&nbsp;
                                            {corpLimitValue?.maxNumOfGeneralUser || 0}&nbsp;
                                            {trI18n('LABEL-ID')}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* LABEL-USAGE-STATUS */}
                            <div
                                className={`accordionForm ${hanldeToggleCollapse(labelUsageStatus)}`}
                                id="label-usage-status"
                            >
                                <label
                                    className="accordionHead accordionHead-text"
                                    onClick={() => handleToggleSection(setLabelUsageStatus)}
                                >
                                    {trI18n('LABEL-USAGE-STATUS')}
                                </label>
                                <div className="accordionContent">
                                    <div className="accordion normal-underline pt-1">
                                        <span className="normal-label">
                                            {trI18n('LABEL-TABLE-USAGE-DETAIL')}
                                        </span>
                                        <span className="normal-content">
                                            {trI18n('LABEL-TABLE-USAGE-STATUS')}
                                        </span>
                                    </div>
                                    {usageStageItems.map(item =>
                                        renderUsingStageItem({ item, usageStageItems })
                                    )}
                                </div>
                            </div>

                            {/* LABEL-USED-FUNCTIONS */}
                            <div
                                className={`accordionForm ${hanldeToggleCollapse(
                                    labelUsedFunctions
                                )}`}
                                id="label-used-functions"
                            >
                                <label
                                    className="accordionHead accordionHead-text"
                                    onClick={() => handleToggleSection(setLabelUsedFunctions)}
                                >
                                    {trI18n('LABEL-USED-FUNCTIONS')}
                                </label>
                                <div className="accordionContent service-public">
                                    {usingFunctions(corpLimitValue, corporationData, cataLogData).map(
                                        (item, index) => (
                                            <div className="accordion" key={index}>
                                                <span className="normal-label using-function-settings fw-500">
                                                    {item?.label}
                                                </span>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                );
            }
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN:
                return (
                    <UpdateContract
                        amountValue={amountValue}
                        setAmountValue={setAmountValue}

                        updateContractData={updateContractData}
                        setUpdateContractData={setUpdateContractData}

                        onSaleProductList={onSaleProductList}
                        setOnSaleProductList={setOnSaleProductList}
                        onSaleEditionList={onSaleEditionList}
                        setOnSaleEditionList={setOnSaleEditionList}

                        product={product}
                        setProduct={setProduct}
                        edition={edition}
                        setEdition={setEdition}
                        version={version}
                        setVersion={setVersion}
                        paymentCycle={paymentCycle}
                        setPaymentCycle={setPaymentCycle}

                        payment={payment}
                        setPayment={setPayment}

                        basicSetting={basicSetting}
                        setBasicSetting={setBasicSetting}
                        advanceSetting={advanceSetting}
                        setAdvanceSetting={setAdvanceSetting}

                        currentScreen={currentScreen}
                        isUpdateConfirm={isUpdateConfirm}
                        setIsUpdateConfirm={setIsUpdateConfirm}
                        setIsLoading={setIsLoading}
                        setCheckErr={setCheckErr}
                        props={props}
                        contractDetail={contractDetail?.contractDetail}
                        versionDataCurrent={resetData?.version}
                        currentPaymentCycle={currentPaymentCycle}
                    />
                );
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE_CONFRIM.SCREEN:
                return (<UpdateContractConfirm
                            amountValue={amountValue}
                            advanceSetting={advanceSetting}
                            basicSetting={basicSetting}
                            currentScreen={currentScreen}
                            edition={edition}
                            payment={payment}
                            paymentCycle={paymentCycle}
                            product={product}
                            version={version}
                            contractDetail={contractDetail?.contractDetail}
                        />
                );
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.SCREEN:
                return (
                    <ChoosePaymentConfirm
                        setPaymentMethod={setPaymentMethod}
                        paymentMethod={paymentMethod}
                    />
                );
            default:
                return <LoadingPanel isLoading={isLoading} />;
        }
    };

    const updateDto = {
        corporationId: corporationDetail.id,
        userId: userDetail.id,
        contractId: contractDetail.id,
        method: paymentMethod
    }

    const hanldeCloseUpdateContract = () => {
        closeBtnUpdateContract(
            CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.SCREEN,
            resetData,
            setOnSaleProductList,
            setOnSaleEditionList,
            setProduct,
            setEdition,
            setVersion,
            setPaymentCycle,
            setPayment,
            setBasicSetting,
            setAdvanceSetting,
            setIsUpdateConfirm,
            setIsShowPopupCancel,
            setCheckErr,
            setCurrentScreen,
            setCurrentVersionInfo
        )// delete function if using popup cancel
    }

    return (
        <div className="normal-wrapper">
            <LoadingPanel isLoading={isLoading} />
            <div className="normal-nav normal-underline">
                <div className="normal-btn-group">
                    {redirectBtns.map((btn, index) => (
                        <Button
                            key={index}
                            className={`
                                btn-send btn-hg32 
                                ${btn.outline ? 'btn-primary' : 'btn-outline-primary'} 
                                ${btn.labelKey === 'CM-BUTTON-CANCEL' && 'btn-light'}
                            `}
                            variant="contained"
                            color="primary"
                            data-cy="btn-submit-add-ticket"
                            onClick={async () =>
                                await handleRedirect(
                                    currentScreen,
                                    setCurrentScreen,
                                    btn.labelKey,
                                    setOpenPolicy,
                                    updateDto,
                                    enqueueSnackbar,
                                    props?.API,
                                    setIsLoading,
                                    setCheckErr,
                                    contractDetail,
                                    updateContractData,
                                    setBasicSetting,
                                    setAdvanceSetting,
                                    setIsShowPopUpReload,
                                    product,
                                    edition,
                                    version,
                                    paymentCycle,
                                    payment,
                                    currentVersionInfo,
                                    basicSetting,
                                    advanceSetting,
                                    isUpdateConfirm,
                                    setIsShowPopupCancel,
                                    hanldeCloseUpdateContract,
                                    setTriggerReload
                                )
                            }
                            disabled={btn?.defaultDisable && checkErr}
                        >
                            {trI18n(btn.labelKey)}
                        </Button>
                    ))}
                </div>
            </div>

            {handleRenderScreen(currentScreen)}
            {translationHistoryType && (
                <TranslationHistoryModal
                    affiliationOrganization={
                        contractDetail?.corporationData?.id || corporationDetail.id
                    }
                    usageType={translationHistoryType}
                    titleKey={
                        translationHistoryType === Constant.ROOT_CORPORATION.TRANSLATION_USAGE_TYPE.ON_DEMAND_TEXT
                            ? 'LABEL-TEXT-TRANSLATION-HISTORY-MODAL-TITLE'
                            : 'LABEL-TRANSLATION-HISTORY-MODAL-TITLE'
                    }
                    showPageColumn={
                        translationHistoryType !== Constant.ROOT_CORPORATION.TRANSLATION_USAGE_TYPE.ON_DEMAND_TEXT
                    }
                    onClose={() => setTranslationHistoryType(null)}
                />
            )}
            {isOpenPolicy && (
                <DialogPolicy
                    openPolicy={isOpenPolicy}
                    onShow={kind =>
                        hanldeShowDialogPolicy(isOpenPolicy, setOpenPolicy, setCurrentScreen, kind)
                    }
                />
            )}

            <ConfirmDialog
                isOpen={isShowPopUpReload.isOpen}
                msgConfirm={
                    isShowPopUpReload?.message
                        ? trI18n(isShowPopUpReload?.message)
                        : trI18n('COMMSG030')
                }
                okCallBack={() =>
                    onClickReloadData(setCurrentScreen, setIsShowPopUpReload, setTriggerReload, setPaymentMethod)
                }
            />

            {/* popup cancel: if change data, it will display --> current hidden because outscoped */}
            {false && (
                <ConfirmDialog
                    isOpen={isShowPopupCancel}
                    msgConfirm={trI18n('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                    // okCallBack={}
                    closeCallBack={() =>
                        closeBtnUpdateContract(
                            CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.SCREEN,
                            resetData,
                            setOnSaleProductList,
                            setOnSaleEditionList,
                            setProduct,
                            setEdition,
                            setVersion,
                            setPaymentCycle,
                            setPayment,
                            setBasicSetting,
                            setAdvanceSetting,
                            setIsUpdateConfirm,
                            setIsShowPopupCancel,
                            setCheckErr,
                            setCurrentScreen,
                            setCurrentVersionInfo
                        )
                    }
                    cancelCallBack={() => setIsShowPopupCancel(false)}
                    textSubmit={trI18n('COMBTN002')}
                    textClose={trI18n('COMBTN007')}
                    isShowClassnameButton={false}
                />
            )}
        </div>
    );
}
